<section class="nsw-section">
	<div class="nsw-container">
		<div class="nsw-layout">
			<div class="nsw-layout__main">
				<div class="nsw-grid nsw-grid--spaced">
	
					<div class="nsw-col nsw-col-md-6 nsw-col-lg-4">
						<div class="nsw-card nsw-card--light">
							<div class="nsw-card__image">
								<img src="assets/images/home/content-card-beachwatch-program_compressed.webp"
									alt="Beachwatch program">
							</div>
							<div class="nsw-card__content">				
								<div class="nsw-card__title">
									<a routerLink="/whatIsBeachwatch">Find out about the Beachwatch program</a>
								</div>				
								<span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">east</span>
							</div>
						</div>
					</div>
				
					<div class="nsw-col nsw-col-md-6 nsw-col-lg-4">
						<div class="nsw-card nsw-card--light">
							<div class="nsw-card__image">
								<img src="assets/images/home/content-card-monitor-water_compressed.webp"
									alt="Monitor water">
							</div>
							<div class="nsw-card__content">				
								<div class="nsw-card__title">
									<a routerLink="/waterMonitoring/howWeMonitor">Learn how we monitor water in New South Wales</a>
								</div>				
								<span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">east</span>
							</div>
						</div>
					</div>
				
					<div class="nsw-col nsw-col-md-6 nsw-col-lg-4">
						<div class="nsw-card nsw-card--light">
							<div class="nsw-card__image">
								<img src="assets/images/home/content-card-report-sighting_compressed.webp"
									alt="Report a sighting">
							</div>
							<div class="nsw-card__content">				
								<div class="nsw-card__title">
									<a routerLink="/reportPollution">Report pollution</a>
								</div>				
								<span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">east</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
